// deps-lint-skip: empty
import '../../style/index.less';
import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/drawer/style/index.js
// module id = 1179
// module chunks = 0